import { supabase } from '../lib/supabase';

const BUCKET_NAME = 'recipe-images';
const MAX_FILE_SIZE = 20 * 1024 * 1024; // 20MB

/**
 * Upload an image to Supabase Storage
 * @param {File} file - The image file to upload
 * @param {string} userId - The user's ID for organizing files
 * @returns {Promise<string>} - The public URL of the uploaded image
 */
export const uploadRecipeImage = async (file, userId) => {
  // Validate file size
  if (file.size > MAX_FILE_SIZE) {
    throw new Error(`El archivo es demasiado grande. Máximo ${MAX_FILE_SIZE / 1024 / 1024}MB`);
  }

  // Validate file type
  const allowedTypes = ['image/jpeg', 'image/png', 'image/webp', 'image/gif'];
  if (!allowedTypes.includes(file.type)) {
    throw new Error('Tipo de archivo no permitido. Usa JPG, PNG, WebP o GIF.');
  }

  // Generate unique filename
  const fileExt = file.name.split('.').pop();
  const fileName = `${userId}/${Date.now()}-${Math.random().toString(36).substring(7)}.${fileExt}`;

  // Upload to Supabase Storage
  const { data, error } = await supabase.storage
    .from(BUCKET_NAME)
    .upload(fileName, file, {
      cacheControl: '3600',
      upsert: false
    });

  if (error) {
    console.error('Upload error:', error);
    throw new Error('Error al subir la imagen. Inténtalo de nuevo.');
  }

  // Get public URL
  const { data: { publicUrl } } = supabase.storage
    .from(BUCKET_NAME)
    .getPublicUrl(data.path);

  return publicUrl;
};

/**
 * Delete an image from Supabase Storage
 * @param {string} imageUrl - The full URL of the image to delete
 */
export const deleteRecipeImage = async (imageUrl) => {
  try {
    // Extract the path from the URL
    const url = new URL(imageUrl);
    const pathParts = url.pathname.split(`/storage/v1/object/public/${BUCKET_NAME}/`);
    if (pathParts.length < 2) return;
    
    const filePath = pathParts[1];
    
    const { error } = await supabase.storage
      .from(BUCKET_NAME)
      .remove([filePath]);

    if (error) {
      console.error('Delete error:', error);
    }
  } catch (e) {
    console.error('Error deleting image:', e);
  }
};
